import React from "react";

const LoadingFallback = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin"></div>
                <p className="text-gray-500 font-medium text-sm animate-pulse">
                    Loading amazing things...
                </p>
            </div>
        </div>
    );
};

export default LoadingFallback;
